module.exports = __webpack_public_path__ + "img/add.940a76fd.svg";